import {useRef, useState} from "react";
import {FaChevronDown, FaTimes} from "react-icons/fa";

export const SearchCustomFunc = ({label, selected, selectedName, itens, setFuncionario, setFuncionarioNome, change}) => {
  const [itensExibir, setItensExibir] = useState(itens);
  const [divItens, setDivItens] = useState(false);
  const [tempText, setTempText] = useState('');
  const refInput = useRef(null);

  const updateText = (texto) => {
    setTempText(texto);
    let tempArr = [];
    if (texto !== '') {
      itens.forEach((item) => {
        if (item.nome.toLowerCase().includes(texto.toLowerCase())) {
          tempArr.push(item);
        }
      });
    } else {
      tempArr = [...itens];
    }
    setItensExibir(tempArr);
  }

  return (
    <div className="searchCustom">
      <label>{label}</label>
      <input
        ref={refInput}
        type="text"
        onFocus={() => {
          setDivItens(true);
          updateText('');
        }}
        onChange={(t) => {
          updateText(t.target.value)
        }}
        value={divItens ? tempText : selectedName}
      />
      <div className="searchCustom-icone" onClick={divItens ? () => {
        setDivItens(false)
      } : () => {
        refInput.current.focus()
      }}>{divItens ? <FaTimes/> : <FaChevronDown/>}</div>
      {divItens &&
        <div className="searchCustom-itens">
          {itensExibir.map((item) => (
            <div
              className="searchCustom-item"
              key={item.uuid}
              style={item.uuid === selected ? {backgroundColor: '#dbdbdb'} : {}}
              onClick={() => {
                change(item.uuid, item.nome, item.matricula);
                setTempText('');
                setDivItens(false);
              }}
            >{item.nome}</div>
          ))}
        </div>
      }
    </div>
  );
}